import { useState } from "react";
import { Button, DialogHeader, DialogBody, DialogFooter, Textarea } from "@material-tailwind/react";
import { Modal } from "./Modal";
import i18next, { t } from "i18next";

export const RateSongModal = ({ like, songName, ...props }) => {
  const [comment, setComment] = useState('WebUI');
  return (
    <Modal {...props}>{({ handleConfirm, handleCancel }) => <>
      <DialogHeader>
        <div>{t('dialogs.rate_request.confirm_rate_line', { action: like ? t('dialogs.rate_request.like') : t('dialogs.rate_request.dislike') })}</div>
      </DialogHeader>
      <DialogBody>
        <span className={`${i18next.language == 'en' ? 'lowercase' : ''}`}>{t('dialogs.rate_request.question', { action: like ? t('dialogs.rate_request.like') : t('dialogs.rate_request.dislike') })}</span>
        <div className="font-bold text-3xl font-bebasneue tracking-wider my-2">
          {songName}
        </div>
        <Textarea label={t('dialogs.your_comment')} onChange={e => setComment('WebUI: ' + e.target.value)} />
      </DialogBody>
      <DialogFooter>
        <Button variant="filled" color="yellow" onClick={handleCancel} className="mr-2">
          <span>{t('dialogs.no')}</span>
        </Button>
        <Button variant="filled" color="yellow" onClick={() => handleConfirm({ comment })}>
          <span>{t('dialogs.yes')}</span>
        </Button>
      </DialogFooter>
    </>}</Modal>
  );
};
